<template>
  <div class="employeeRoster page-customer">
    <div class="topOperation">
      <div class="top-left">
        <div>
          <ShowNavHead />
        </div>
        <div class="screenInputs">
          <div class="screenInput">
            <div class="flname">项目名称</div>
            <!-- <el-input size="small" v-model="infoQuery.objname" @blur="getCustomerList()" @keyup.enter.native="$event.target.blur"></el-input> -->
            <el-input size="small" v-model="infoQuery.objname" @keyup.enter.native="getCustomerList"></el-input>
          </div>
          <div class="screenInput">
            <div class="flname">导入状态</div>
            <el-select v-model="infoQuery.stremptype" placeholder="请输入或选择" filterable @change="getCustomerList">
              <el-option label="已导入" value="1"></el-option>
              <el-option label="未导入" value="2"></el-option>
              <el-option label="全部" value="0"></el-option>
            </el-select>
          </div>
        </div>
      </div>
      <div class="top-right" style="margin-right:30px">
        <el-dropdown v-if="strTableId.indexOf('XZ_emp_FnncSocialInsu')>-1" @command="handleCommand">
          <el-button type="success" plain>
            社保<i class="el-icon-arrow-down el-icon--right"></i>
          </el-button>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command="a">社保导入</el-dropdown-item>
            <el-dropdown-item command="b">查看社保详情</el-dropdown-item>
            <el-dropdown-item command="e">删除社保信息</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
        <el-dropdown v-if="strTableId.indexOf('XZ_emp_FnncProCost')>-1" @command="handleCommand">
          <el-button type="success" plain>
            费用<i class="el-icon-arrow-down el-icon--right"></i>
          </el-button>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command="c">费用导入</el-dropdown-item>
            <el-dropdown-item command="d">查看详情</el-dropdown-item>
            <el-dropdown-item command="f">删除费用数据</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
        <!-- <button class="search" @click="otherImp(2)" v-if="strTableId.indexOf('XZ_emp_FnncProCost')>-1">费用导入</button> -->
        <el-button type="text" @click="dropDownScreen">
          <img src="../../assets/employee/images/screen.png" />
          <span>筛选</span>
        </el-button>
      </div>
      <!-- 筛选下拉框 -->
      <div class="dropDownScreen" v-show="showDropScreen==1">
        <div class="inputs">
          <div class="formScreenInput">
            <div>服务中心</div>
            <el-select v-model="infoQuery.strsrvcent" placeholder="请输入或选择" filterable @change="serviceChange">
              <el-option v-for="(item,index) in serviceList" :key="index" :label="item.StrSrvCent" :value="item.StrSrvCent"></el-option>
            </el-select>
          </div>
          <div class="formScreenInput">
            <div>业务立项部门</div>
            <el-select v-model="infoQuery.strobjinstname" placeholder="请输入或选择" filterable>
              <el-option v-for="(item,index) in apartmentList" :key="index" :label="item.StrObjInstName" :value="item.StrObjInstName"></el-option>
            </el-select>
          </div>
          <div class="formScreenInput">
            <div>负责客服</div>
            <el-input size="small" v-model="infoQuery.strusername" placeholder="请输入负责客服"></el-input>
          </div>
        </div>
        <div class="drop-footer">
          <button class="clear" style="margin-right:10px" @click="resetHandle()">清空</button>
          <button class="search" @click="serarchHandle()">搜索</button>
          <button class="clear" @click="showDropScreen=-1">关闭</button>
        </div>
      </div>
    </div>

    <div class="main-con">
      <div class="crumbs">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item>工资清单</el-breadcrumb-item>
          <el-breadcrumb-item>客户列表</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="financeRosterTable">
        <el-table :data="tableData" :max-height="tableHeight-180" style="width: 99%" @cell-click="handdle" :cell-style="columnStyle" v-loading="listLoading">
          <el-table-column align="center" label="序号" width="50">
            <template slot-scope="{$index}">
              <span>{{(Number(infoQuery.currpage) - 1) * Number(infoQuery.pagecount) + Number($index) + 1}}</span>
            </template>
          </el-table-column>
          <el-table-column align="center" label="项目名称" prop="StrObjName">
            <template slot-scope="scope">
              <div style="color:#19bd92">{{scope.row.StrObjName ? scope.row.StrObjName : '-'}}</div>
            </template>
          </el-table-column>
          <el-table-column align="center" label="服务中心" prop="StrSrvCent">
            <template slot-scope="scope">
              {{scope.row.StrSrvCent ? scope.row.StrSrvCent : '-'}}
            </template>
          </el-table-column>
          <el-table-column align="center" label="公司" prop="StrBlCmp">
            <template slot-scope="scope">
              {{scope.row.StrBlCmp ? scope.row.StrBlCmp : '-'}}
            </template>
          </el-table-column>
          <el-table-column align="center" label="业务立项部门" prop="StrObjInstName">
            <template slot-scope="scope">
              {{scope.row.StrObjInstName ? scope.row.StrObjInstName : '-'}}
            </template>
          </el-table-column>
          <el-table-column align="center" label="负责客服" prop="StrUserName">
            <template slot-scope="scope">
              {{scope.row.StrUserName ? scope.row.StrUserName : '-'}}
            </template>
          </el-table-column>
          <el-table-column align="center" label="记账月份">
            <template slot-scope="scope">
              {{scope.row.BookingRealMonth ? scope.row.BookingRealMonth : '-'}}
            </template>
          </el-table-column>
          <el-table-column align="center" label="归属月份">
            <template slot-scope="scope">
              {{scope.row.BelongMonth ? scope.row.BelongMonth : '-'}}
            </template>
          </el-table-column>
          <el-table-column align="center" label="操作" fixed="right" width="220px">
            <template slot-scope="scope">
              <div style="display:flex;justify-content: center">
                <el-button v-if="isCanHandle" class="changeState" @click="importInfo(scope.row)" :disabled="nowMonth==scope.row.BelongMonth">导入</el-button>
                <el-button v-if="isCanHandle && (roleType=='adminuser' || roleType=='manager' || roleType=='adminusers')" class="changeState" @click="importInfo(scope.row)">重新导入</el-button>
                <el-button v-if="isCanHandle && (roleType=='adminuser' || roleType=='manager' || roleType=='adminusers')" class="pinkButton" :disabled="!scope.row.BookingRealMonth" @click="deleteHandle(scope.row.StrObjName,'XZ_emp_Fnnc')">删除</el-button>
              </div>
            </template>
          </el-table-column>
        </el-table>
        <div class="block" v-if="totalcount>0">
          <el-pagination @current-change="handleCurrentChange" @size-change="handleSizeChange" :current-page.sync="currentPage" :page-sizes="[10, 20, 50, 100]" :page-size="pageSize" layout="total,sizes,prev,pager, next, jumper" :total="totalcount"></el-pagination>
        </div>
      </div>
    </div>

    <div class="dialog">
      <!-- 导入模板下载 -->
      <el-dialog :visible.sync="dialogVisible3" width="480px">
        <div class="diaTitle">导入模板下载</div>
        <div style="padding:10px 0px 20px ">
          <p>注：所有日期格式都是YYYY-MM-DD格式</p>
          <a :href="this.modepath">点击下载</a>
        </div>
        <span slot="footer" class="dialog-footer">
          <button class="clear" @click="dialogVisible3 = false">取消</button>
          <button class="search" @click="dialogVisible3 = false" style="margin-left:10px;font-weight:600"><a :href="this.modepath" style="font-weight: 600;color: #19BD92;">点击下载</a></button>
        </span>
      </el-dialog>
      <!-- 删除 -->
      <el-dialog :visible.sync="delDialog" width="580px">
        <div class="diaTitle">删除 {{exportName}} 数据</div>
        <div class="flex impdata" style="margin:20px 0">
          <div class="bookkeepingMonth">
            <div class="impTitle">记账月份:</div>
            <el-date-picker v-model="bookDate" :picker-options="pickerOptions" type="month" placeholder="选择月" value-format="yyyy-MM" @change="selectMonth"></el-date-picker>
          </div>
          <div class="bookkeepingMonth">
            <div class="impTitle">归属月份:</div>
            <el-date-picker v-model="belongMonth" :picker-options="pickerOptions" type="month" placeholder="选择月" value-format="yyyy-MM" @change="selectMonth"></el-date-picker>
          </div>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button size="medium" style="margin-right:15px" @click="delDialog = false">取消</el-button>
          <el-popconfirm :title="'确认要删除  ' + exportName + '  的所有数据'" icon="el-icon-info" icon-color="red" @confirm="confirmDel">
            <el-button size="medium" slot="reference" type="danger">确认删除</el-button>
          </el-popconfirm>
        </span>
      </el-dialog>
      <!-- 导入 -->
      <el-dialog :visible.sync="dialogVisible5" width="700px">
        <div class="diaTitle">导入数据 至 {{exportName}}</div>
        <el-steps :active="active" finish-status="success" class="steps-box">
          <el-step title="基础信息"></el-step>
          <el-step title="上传导入文件"></el-step>
          <el-step title="导入处理"></el-step>
        </el-steps>
        <div v-if="active==0" style="margin-top:15px;padding-bottom:15px;">
          <div class="flex">
            <div>
              <div class="impTitle">导入表格:</div>
              <div class="storageInput" style="margin:0 20px 0 0">
                <el-select v-model="tabName" slot="prepend" placeholder="请选择" filterable @change="selectTab">
                  <el-option v-for="(item, index) in tableList" :key="index" :label="item.StrTableName" :value="{value:item.StrTableId,label:item.StrTableName}"></el-option>
                </el-select>
              </div>
            </div>
            <div style="margin-left:10px">
              <div>导入模板下载:</div>
              <el-button type="text" @click="downLoadHandle" style="margin-left:15px;height:30px;margin-top:10px">下载模板</el-button>
            </div>
          </div>
          <div class="flex impdata">
            <div class="bookkeepingMonth">
              <div class="impTitle">记账月份:</div>
              <el-date-picker v-model="bookDate" :picker-options="pickerOptions" type="month" placeholder="选择月" value-format="yyyy-MM" @change="selectMonth"></el-date-picker>
            </div>
            <div class="bookkeepingMonth">
              <div class="impTitle">归属月份:</div>
              <el-date-picker v-model="belongMonth" :picker-options="pickerOptions" type="month" placeholder="选择月" value-format="yyyy-MM" @change="selectMonth"></el-date-picker>
            </div>
          </div>
        </div>
        <div v-if="active==1" style="margin-top:15px;padding-bottom:15px;">
          <div class="note-txt">
            <p style="font-weight:bold;">上传文件说明：</p>
            <p>1. 支持文件后缀 xls、xlsx文件。
            </p>
            <p>2. 请将要上传的内容放在第一个sheet中。
            </p>
            <p>3. 请不要加密模板文件，将导致错误。
            </p>
            <p>4. 请不要上传带宏的文件，将导致错误。
            </p>
            <p>5. 请不要过多的使用格式，如背景色和边框，将可能导致超时。
            </p>
            <p>6. 导入后只会保留Excel中的数据及通过公式计算后的值，设置的文字颜色等样式、合并的单元格、以及计算公式本身都不会被保留。</p>
          </div>
          <div style="margin-top:10px">请选择导入文件（xls/xlsx格式）:</div>
          <div class="form-item" style="justify-content: space-between;">
            <div class="file-box">
              <input readonly style="width: 368px;height:32px" id="applyLicense" type="text" v-model="ExcelSrc.fileName" autocomplete="off">
              <input id="fileInput" type="file" name="file" accept=".xlsx,.xls" @change="importf(this)" ref="upload">
              <label for="fileInput" class="file-btn">上传</label>
            </div>
            <el-button type="text" @click="downLoadHandle" style="margin-left:15px;height:30px;">下载模板</el-button>
          </div>
          <!-- 提示 -->
          <p style="color:red;" v-if="isError">{{errorTxt}}</p>
          <div class="reimpArea">
            <div style="margin-top:10px">
              <!-- <el-checkbox v-model="isReset" @change="selectReimp">是否覆盖导入</el-checkbox> -->
              <!-- <el-radio v-model="reimpLab" label="0" border size="small" @change="selectReimp">否</el-radio>
                <el-radio v-model="reimpLab" label="1" border size="small" @change="selectReimp">是</el-radio> -->
            </div>
          </div>
        </div>
        <div v-if="active==2" style="margin-top:15px;padding-bottom:15px;">
          <div class="result-box">
            <p><i class="el-icon-success" style="color: #409EFF;margin-right:5px"></i>导入数据正在处理中，导入结果请在’导入记录‘中查看。</p>
          </div>
        </div>
        <div style="display:flex;justify-content:flex-end;-webkit-justify-content:flex-end;padding-bottom: 30px;">
          <el-button size="small" @click="dialogVisible5 = false" v-if="active==0">取消</el-button>
          <el-button size="small" @click="prevSteps" v-if="active>0 && active<=1">上一步</el-button>
          <el-button type="primary" size="small" @click="nextSteps" v-if="(active<1 && impType!='社保') || (active<1&&impType=='社保'&&isimp==0)">下一步</el-button>
          <el-popconfirm style="margin-left:15px" confirm-button-text='删除旧数据重新导入' cancel-button-text='不删除旧数据，继续导入' icon="el-icon-info" icon-color="red" v-if="active<1 && (impType=='社保'&&isimp!=0)" title="该月份已经导入过数据，请问是否删除之前导入的数据重新导入？" @confirm="nextDel" @cancel="nextSteps">
            <el-button slot="reference" type="primary" size="small">下一步</el-button>
          </el-popconfirm>
          <el-tooltip effect="dark" content="未上传文件不能提交" :disabled="!isUploadSuccess" placement="top">
            <div style="display:inline-block;margin-left:10px">
              <el-button type="success" size="small" @click="lastSteps" element-loading-text="此操作可能耗费较长时间，请等待..." element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.8)" v-loading.fullscreen.lock="fullscreenLoading" v-if="active==1" :disabled="isUploadSuccess">提交</el-button>
            </div>
          </el-tooltip>
          <el-button type="primary" size="small" @click="backHandle" v-if="active==2">确认并返回</el-button>
          <el-button size="small" @click="resultHandle" v-if="active==2">查看导入结果</el-button>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import { parseTime } from '../../utils' //格式化时间格式
import FUN from "../../fun";
import xz from "../../common";
export default {
  data() {
    return {
      //关账日期查询参数
      closeQuery: {
        currpage: 1,
        perpage: 10
      },
      rowdate: {
        bookingRealMonth: '',
        bookDate: ''
      },
      //是否下载过新的客服模板
      isFnnCusIsDownload: false,
      //是否下载过新的社保模板
      isSocDownload: false,
      //是否下载过新的费用模板
      isCostDownload: false,
      //是否下载过新的利润表模板
      isProDownload: false,
      //是否下载过新的项目开票信息表模板
      isPjtDownload: false,
      //是否导入过
      isimp: 0,
      closeDate: '',
      nowMonth: parseTime(new Date(), '{y}-{m}'),
      roleType: '',
      impType: "",
      strTableId: "",
      //归属日期
      belongMonth: "",
      //记账日期
      bookDate: "",
      rowinfo: null,
      //在/离职状态
      workState: '',
      //导出弹窗
      tablePath: this.$store.state.EMP.tablePath,
      tableHeight: 0,
      //所有导入字段
      currFileData: [],
      checkAll: false,
      checkedFields: [],
      fields: [],
      tableclumn: [],
      isIndeterminate: true,
      //表头错误提示
      isError: false,
      errorTxt: '',
      listLoading: false,
      //导入模板链接
      modepath: "",
      //导入到的项目名称
      exportName: '',
      //是否覆盖
      isReset: false,
      pageSize: 10,
      //页面展示数量
      pagecount: 10,
      //第几页
      currpage: 1,
      //数据数量
      totalcount: null,
      //导入步骤
      active: 0,
      //文件是否已上传
      isFileSuccess: false,
      //文件
      files: "",
      fileName: "",
      searchDown: "",
      ExcelSrc: {
        value: "",
        check: false,
        fileName: ""
      },
      entid: "",
      excelpath: '',
      showResult: false,
      fullscreenLoading: false,
      currentPage: 1,
      instname: "",
      reimp: 0,
      reimpLab: "0",
      StrUserName: "",
      StrSrvCent: "",
      StrObjName: "",
      //下拉筛选
      showDropScreen: -1,
      // dialogVisible: false,
      //导入模板下载
      dialogVisible3: false,
      //导入
      dialogVisible5: false,
      tabName: '',
      tabId: "",
      tableList: [],
      tableData: [],
      //下拉服务中心列表
      serviceList: [],
      //下拉业务立项部门
      apartmentList: [],
      //列表参数
      infoQuery: {
        pagecount: "10",
        currpage: 1,
        objname: "",//项目名称
        ctluserid: "",
        strsrvcent: "",//服务中心
        strobjinstname: "",//立项部门
        strusername: "",//客服名称
        strbusistat: "",//服务状态
        stremptype: "0",
        strTableId: ''
      },
      //上传excel是否成功-判断下一步按钮是否禁用
      isUploadSuccess: true,
      allFieldList: [],
      //导入状态查询参数
      stateInfoQuery: {
        pagecount: 10,
        currpage: 1,
        excelname: "",
        tableid: "XZ_emp_UserBase",
        instname: "",
        datestart: "",
        dateend: "",
        objname: "",
        strobjinstname: "",
        strusername: "",
        impdate: ''
      },
      //禁用日期范围
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        }
      },
      //判断提交导入是否有返回
      isComeBack: false,
      //删除弹窗
      delDialog: false,
      // 按钮权限参数
        butQuery:{
          roletype:'',
          page:'employee-fnnclst'
        },
        // 是否有权限操作按钮
        isCanHandle:false
    }
  },
  async created() {
    this.butQuery.roletype = localStorage.loginRoletype
    this.getButtonPower()
    if (window.localStorage.getItem('strTableId')) {
      this.strTableId = window.localStorage.getItem('strTableId');
      this.infoQuery.strTableId = this.strTableId;
      // console.log('f', window.localStorage.getItem('strTableId'))
    }
    //社保
    if (this.strTableId.indexOf('XZ_emp_FnncSocialInsu') > -1) {
      if (window.localStorage.getItem('isSocDownload')) {
        this.calDaysBetween(window.localStorage.getItem('isSocDownload'), 'soc')
      }
    }
    //费用
    if (this.strTableId.indexOf('XZ_emp_FnncProCost') > -1) {
      if (window.localStorage.getItem('isCostDownload')) {
        this.calDaysBetween(window.localStorage.getItem('isCostDownload'), 'cost')
      }
    }
    //利润表
    if (this.strTableId.indexOf('XZ_emp_FnncProfit') > -1) {
      if (window.localStorage.getItem('isProDownload')) {
        this.calDaysBetween(window.localStorage.getItem('isProDownload'), 'profit')
      }
    }
    //项目开票信息
    if (this.strTableId.indexOf('XZ_emp_FnncProjectInvoice') > -1) {
      if (window.localStorage.getItem('isPjtDownload')) {
        this.calDaysBetween(window.localStorage.getItem('isPjtDownload'), 'invoice')
      }
    }
    if (window.localStorage.getItem('isFnnCusIsDownload')) {
      this.calDaysBetween(window.localStorage.getItem('isFnnCusIsDownload'), 'cus')
    }
    if (window.localStorage.getItem('loginRoletype')) {
      this.roleType = window.localStorage.getItem('loginRoletype');
    }
    if (window.localStorage.getItem('closeAccountType')) {
      // console.log('closeAccountType', window.localStorage.getItem('closeAccountType'))
      if (window.localStorage.getItem('closeAccountType') != 1) {
        this.closeHandle();
      }
    }
    this.calHeight();
    this.getTabInfo();
    this.getCustomerList();
    this.getServiceList()
    this.getApartmentList()
  },
  methods: {
    calHeight() {
      this.tableHeight = Number(document.body.clientHeight);
    },
    // 获取按钮权限
    getButtonPower(){
      xz.getJbUserRolepageDetail(this.butQuery.roletype, this.butQuery.page).then(res => {
        // console.log('按钮',res)
        if(res.status == 'ok'){
          let powerVal  = res.msg[0].Buttons
          if(powerVal == 'search'){
            // 只能查看
            this.isCanHandle = false
          }else if(powerVal == 'update'){
            // 特殊处理 只能更改客服
            this.isCanHandle = false
          }else if(powerVal == 'operation'){
            // 可操作
            this.isCanHandle = true
          }
        }else{
          this.isCanHandle = false
        }
      })
    },
    //删除弹窗
    deleteHandle(custname, id) {
      this.belongMonth = "";
      this.bookDate = "";
      this.exportName = custname;
      this.tabId = id;
      this.delDialog = true;
    },
    //确认删除
    confirmDel() {
      if (this.exportName == '项目收支表费用') {
        if (!this.bookDate) {
          this.$message.warning('请选择记账日期');
          return false;
        }
      } else {
        if (!this.belongMonth || !this.bookDate) {
          this.$message.warning("请选择记账月份和归属月份")
          return false;
        }
      }
      const data = {
          strObjName: this.exportName,
          tableid: this.tabId,
          bookingRealMonth: this.bookDate,
          belongMonth: this.belongMonth
        }
        xz.delfnncuserimport(data).then(res => {
          if (res) {
            this.$message.success("删除成功！");
            this.getCustomerList();
            this.delDialog = false;
          } else {
            this.$message.fileid("删除失败！");
            this.delDialog = false;
          }
        })
      //  else {
      //   this.$message.warning("请选择记账月份和归属月份")
      // }
    },
    //重新导入前的删除
    nextDel() {
      this.fullscreenLoading = true;
      const data = {
        strObjName: this.exportName,
        tableid: this.tabId,
        bookingRealMonth: this.bookDate,
        belongMonth: this.belongMonth
      }
      xz.delfnncuserimport(data).then(res => {
        if (res) {
          this.$message.success("删除成功！");
          this.nextSteps();
          this.fullscreenLoading = false;
        } else {
          this.$message.fileid("删除失败！");
        }
      })
    },
    //关账禁用的时间
    closeHandle() {
      xz.getaccountDate(this.closeQuery).then(res => {
        // console.log('sdf',res)
        if (res.msg && res.msg.length > 0) {
          this.closeDate = res.msg[0].Cfgvalue;
          let closeDates = res.msg[0].Cfgvalue;
          this.pickerOptions = {
            disabledDate(time) {
              let disabledTime = (Date.now() < time.getTime()) || (time.getTime() < new Date(closeDates).getTime() + 30 * 24 * 60 * 60 * 1000)
              // console.log('disabledTime',disabledTime)
              return disabledTime
            }
          }
        }
      })
    },
    //下一步导入
    nextSteps() {
      // if (this.active++ > 2) this.active = 0;
      if (this.active == 0) {
        if (this.tabName == '') {
          this.$message({
            message: "请选择导入模板",
            type: "warning"
          });
          this.active = 0
          return false
        }
        if (this.impType == '客服') {
          console.log('isfs', this.rowdate)
          if (this.rowdate.bookDate == this.bookDate && this.rowdate.belongMonth == this.belongMonth) {
            this.$message({
              message: "该月份已经导入过，需要重新导入请联系客服经理",
              type: "warning",
              duration: 5000
            });
            return false
          }
          if (!this.isFnnCusIsDownload) {
            this.$message({
              message: "请先下载导入模板，下一步导入请使用新的模板导入",
              type: "warning",
              duration: 5000
            });
            return false
          }
        } else if (this.impType == '社保') {
          if (!this.isSocDownload) {
            this.$message({
              message: "请先下载导入模板，下一步导入请使用新的模板导入",
              type: "warning",
              duration: 5000
            });
            return false
          }
        } else if (this.impType == '费用') {
          if (!this.isCostDownload) {
            this.$message({
              message: "请先下载导入模板，下一步导入请使用新的模板导入",
              type: "warning",
              duration: 5000
            });
            return false
          }
        } else if (this.impType == '利润表') {
          if (!this.isProDownload) {
            this.$message({
              message: "请先下载导入模板，下一步导入请使用新的模板导入",
              type: "warning",
              duration: 5000
            });
            return false
          }
        } else if (this.impType == '项目开票信息表') {
          if (!this.isPjtDownload) {
            this.$message({
              message: "请先下载导入模板，下一步导入请使用新的模板导入",
              type: "warning",
              duration: 5000
            });
            return false
          }
        }
        if (this.impType == '费用' || this.impType == '利润表' || this.impType == '项目开票信息表') {
          if (!this.bookDate) {
            this.$message.warning('请选择记账月份')
            return false
          }
        } else {
          if (!this.belongMonth || !this.bookDate) {
            this.$message.warning('请选择归属月份和记账月份')
            return false
          }
        }
      }
      this.active += 1
    },
    //上一步导入
    prevSteps() {
      this.active -= 1
    },
    //提交导入
    async lastSteps() {
      if (this.ExcelSrc.value == '') {
        this.isUploadSuccess = true
        this.$message({
          message: "请选择文件上传",
          type: "warning"
        });
        this.active = 1
        return false
      }
      else {
        //检查表头是否正确
        let checkData = {
          excelpath: this.excelpath,
          tableid: this.tabId,
          fileid: this.tabName
        }
        this.fullscreenLoading = true;
        xz.chkfinanceimpdatatbtype(checkData).then(res => {
          // console.log('checkData',res)
          let resultTxt = res
          // console.log('resultTxt',this.isNull(res))
          if (this.isNull(res)) {
            this.isError = false
            this.isUploadSuccess = false;
            let Edata = {};
            if (this.impType == '客服') {
              Edata = {
                instname: this.instname,
                tableid: this.tabId,
                reimp: this.reimp,
                excelpath: this.excelpath,
                impexcel: this.ExcelSrc.fileName,
                servusrname: this.StrUserName,
                servcentname: this.StrSrvCent,
                custname: this.StrObjName,
                fileid: this.tabName,
                bookingRealMonth: this.bookDate,
                belongMonth: this.belongMonth
              }
            } else {
              Edata = {
                instname: '',
                tableid: this.tabId,
                reimp: this.reimp,
                excelpath: this.excelpath,
                impexcel: this.ExcelSrc.fileName,
                servusrname: '',
                servcentname: '杰博',
                custname: this.tabName,
                fileid: this.tabName,
                bookingRealMonth: this.bookDate,
                belongMonth: this.belongMonth
              }
            }
            console.log('edata', Edata)
            xz.financeAnlysisExcelInf(Edata).then(res => {
              if (res) {
                this.active = 2
              } else {
                this.$message('导入错误');
              }
              this.fullscreenLoading = false;
              // this.isUploadSuccess = true
            })
          } else {
            this.isError = true
            this.active = 1
            this.isUploadSuccess = true
            this.errorTxt = resultTxt
            //导入操作，如果第一次导入某个文件会触发导入操作，但是第二次导入重复该文件，不会触发操作
            //清空input file值
            var file = document.getElementById("fileInput");
            file.value = "";
            this.fullscreenLoading = false;
          }
        })
      }
    },
    //判断是否为空(包含0)
    isNull(o) {
      return o == undefined || o == "undefined" || (o + '').indexOf("undefined") > -1 || o == null || o == '' || o == 'null' || o == [] || o == 0 || o == 'NaN';
    },
    //导入-确认返回
    backHandle() {
      this.dialogVisible5 = false
      this.getCustomerList()
    },
    //查看导入结果
    resultHandle() {
      this.dialogVisible5 = false
      this.$router.push({
        path: "/employee-fnnchis",
      })
    },
    //下载模板
    downLoadHandle() {
      let tabId = 'output_' + this.tabId;
      xz.getfinanceinputmode(this.tabName, tabId).then(res => {
        if (res.msg) {
          if (this.impType == '客服') {
            this.isFnnCusIsDownload = true;
            window.localStorage.setItem('isFnnCusIsDownload', new Date())
          } else if (this.impType == '社保') {
            this.isSocDownload = true;
            window.localStorage.setItem('isSocDownload', new Date())
          } else if (this.impType == '费用') {
            this.isCostDownload = true;
            window.localStorage.setItem('isCostDownload', new Date())
          } else if (this.impType == '利润表') {
            this.isProDownload = true;
            window.localStorage.setItem('isProDownload', new Date())
          } else if (this.impType == '项目开票信息表') {
            this.isPjtDownload = true;
            window.localStorage.setItem('isPjtDownload', new Date())
          }
          var d = res.msg.data.StrOutPath
          d = d.replace("\"", "").replace("\"", "")
          var path = this.tablePath + d
          const aTag = document.createElement('a')
          aTag.href = path
          aTag.click();
        } else {
          this.$message.warning('还没有导入模板，请联系管理员上传导入模板')
        }
      })
    },
    //计算相差天数
    calDaysBetween(date, type) {
      let startDate = Date.parse(date);
      let endDate = Date.parse(new Date());
      let days = (endDate - startDate) / (1 * 24 * 60 * 60 * 1000);
      if (type == 'cus') {
        days > 7 ? this.isFnnCusIsDownload = false : this.isFnnCusIsDownload = true;
      } else if (type == 'soc') {
        days > 7 ? this.isSocDownload = false : this.isSocDownload = true;
        // console.log('soc', this.isSocDownload)
      } else if (type == 'cost') {
        days > 7 ? this.isCostDownload = false : this.isCostDownload = true;
      } else if (type == 'profit') {//利润
        days > 7 ? this.isProDownload = false : this.isProDownload = true;
      } else if (type == 'invoice') {//项目开票信息
        days > 7 ? this.isPjtDownload = false : this.isPjtDownload = true;
      }
    },
    //获取导入表
    getTabInfo() {
      const gdata = {
        pagecount: 10,
        currpage: 1,
        tablename: "",
        ctluserid: "",
        strTableId: this.strTableId
      };
      // console.log('strTableId',this.strTableId)
      xz.getfinanceemptabledef(gdata, Cookies.get("userid-b")).then(res => {
        this.tableList = res.data;
        if (res.data && res.data.length > 0) {
          this.tabName = res.data[0].StrTableName;
          this.tabId = res.data[0].StrTableId;
        } else {
          this.tabName = '';
          this.tabId = ''
        }
        // console.log('tablelist',this.tableList)
      });
    },
    //翻页
    handleCurrentChange(val) {
      // console.log(`当前页: ${val}`);
      this.infoQuery.currpage = `${val}`;
      // console.log('page',this.currpage)
      this.getCustomerList();
    },
    //切换列表的size
    handleSizeChange(val) {
      // console.log(`每页 ${val} 条`);
      this.infoQuery.pagecount = `${val}`;
      this.pageSize = parseInt(val);
      this.getCustomerList();
    },
    serviceChange() {
      this.getApartmentList(this.infoQuery.strsrvcent, this.infoQuery.strobjname)
    },
    //下拉服务中心列表
    getServiceList() {
      xz.getsrarchinstlist().then(res => {
        // console.log("getServeList", res);
        let dataList = []
        for (let index = 0; index < res.length; index++) {
          const service = res[index];
          dataList.push({ StrSrvCent: service.Strinstname })
        }
        // console.log("getServeList", dataList);
        this.serviceList = dataList;
      });
    },
    //下拉立项部门
    getApartmentList(strsrvcent, strobjname) {
      xz.getsrarchinstobjinstlist(strsrvcent, strobjname).then(res => {
        // console.log("getApartmentList", res);
        let dataList = []
        for (let index = 0; index < res.length; index++) {
          const apartmentData = res[index];
          dataList.push({ StrObjInstName: apartmentData.StrObjInstName })
        }
        // console.log("getServeList", dataList);
        this.apartmentList = dataList;
      });
    },
    //清空
    resetHandle() {
      this.infoQuery = {
        pagecount: this.pagecount,
        currpage: 1,
        objname: "",//项目名称
        ctluserid: "",
        strsrvcent: "",//服务中心
        strobjinstname: "",//立项部门
        strusername: "",//客服名称
        strbusistat: "", //服务状态
      }
      this.infoQuery.strTableId = this.strTableId;
    },
    //搜索
    serarchHandle() {
      this.infoQuery.currpage = 1;
      this.getCustomerList();
    },
    //点击客户转跳到客户花名册
    handdle(row, event, column, cell) {
      var custname = row.StrObjName;
      let bookDate = row.BookingRealMonth;
      let belongMonth = row.BelongMonth;
      let StrTableId = 'XZ_emp_Fnnc';
      if (event.label == "项目名称") {
        this.$router.push({
          path: "/financialRoster",
          query: {
            custname,
            StrTableId,
            bookDate,
            belongMonth
          }
        })
      }
    },
    handleCommand(command) {
      console.log(command)
      if (command == 'a') {
        this.otherImp(1)
      } else if (command == 'b') {
        this.toDetails('项目收支表社保', 'XZ_emp_FnncSocialInsu')
      } else if (command == 'c') {
        this.otherImp(2)
      } else if (command == 'd') {
        this.toDetails('项目收支表费用', 'XZ_emp_FnncProCost')
      } else if (command == 'e') {
        this.deleteHandle('项目收支表社保', 'XZ_emp_FnncSocialInsu')
      } else if (command == 'f') {
        this.deleteHandle('项目收支表费用', 'XZ_emp_FnncProCost')
      }
    },
    //查看社保/费用详情
    toDetails(name, id) {
      this.$router.push({
        path: "/financialRoster",
        query: {
          custname: name,
          StrTableId: id,
          belongMonth: parseTime(new Date(), '{y}-{m}'),
          bookDate: parseTime(new Date(), '{y}-{m}'),
        }
      })
    },
    columnStyle({ row, column, rowIndex, columnIndex }) {
      if (column.label == "项目名称") {
        return "cursor: pointer";
      }
    },
    //查询导入状态
    queryImportState(val) {
      this.stateInfoQuery.strsrvcent = val.StrSrvCent;
      this.stateInfoQuery.strobjname = val.StrObjName;
      xz.getPathInfo(this.stateInfoQuery).then(res => {
        if (res) {
          if (res.data.length > 0) {
            let opTime = res.data[0].StrImpBdateStr.substring(0, 4) + "/" + res.data[0].StrImpBdateStr.substring(4, 6)
              + "/" + res.data[0].StrImpBdateStr.substring(6, 8) + " " + res.data[0].StrImpBdateStr.substring(8, 10)
              + ":" + res.data[0].StrImpBdateStr.substring(10, 12);
            if (new Date().getTime() > new Date((new Date(opTime)).valueOf() + 360000).getTime()) {
              this.importInfo(val)
            } else {
              if (res.data[0].StrImpEdateStr != null && res.data[0].StrImpEdateStr != '20' && res.data[0].StrImpEdateStr != '40' && res.data[0].StrImpEdateStr != '60' && res.data[0].StrImpEdateStr != '80') {
                console.log('stateSuccess')
                this.importInfo(val)
              } else {
                this.$message({
                  message: '您有一条正在导入的记录，请在导入完成后再导入',
                  duration: 5000,
                  type: 'warning'
                })
              }
            }
          } else {
            this.importInfo(val)
          }
        } else {
          this.$message.error('系统出错，请联系管理员')
        }
      })
    },
    //客服导入
    importInfo(val) {
      this.rowdate.bookDate = val.BookingRealMonth;
      this.rowdate.belongMonth = val.BelongMonth;
      this.impType = '客服';
      this.tableList = [{
        StrTableId: "XZ_emp_Fnnc",
        StrTableName: "项目收支表客服"
      }]
      this.tabName = '项目收支表客服';
      this.tabId = 'XZ_emp_Fnnc';
      this.dialogVisible5 = true;
      this.errorTxt = ''
      this.ExcelSrc = {
        value: "",
        check: false,
        fileName: ""
      }
      // this.tabName=''
      this.exportName = val.StrObjName;
      this.active = 0;
      this.entid = val.GdObjId;
      this.instname = val.StrObjInstName;
      this.StrUserName = val.StrUserName;
      this.StrSrvCent = val.StrSrvCent;
      this.StrObjName = val.StrObjName;
    },
    //社保、费用导入
    otherImp(d) {
      if (d == 1) {
        this.impType = '社保';
        this.tableList = [{
          StrTableId: "XZ_emp_FnncSocialInsu",
          StrTableName: "项目收支表社保"
        }]
        this.tabName = '项目收支表社保';
        this.tabId = 'XZ_emp_FnncSocialInsu';
        this.exportName = '项目收支表社保'
      } else {
        this.impType = '费用';
        this.tableList = [{
          StrTableId: "XZ_emp_FnncProCost",
          StrTableName: "项目收支表费用"
        },
        {
          StrTableId: "XZ_emp_FnncProfit",
          StrTableName: "利润表"
        },
        {
          StrTableId: "XZ_emp_FnncProjectInvoice",
          StrTableName: "项目开票信息表"
        }
        ]
        this.tabName = '项目收支表费用';
        this.tabId = 'XZ_emp_FnncProCost';
        this.exportName = '费用'
      }
      this.active = 0;
      this.dialogVisible5 = true;
      this.entid = Cookies.get("userid-b");
      this.errorTxt = ''
      this.ExcelSrc = {
        value: "",
        check: false,
        fileName: ""
      }
    },
    //重新导入
    reImport() {
      this.dialogVisible6 = false;
      this.dialogVisible5 = true;
    },
    selectMonth(date) {
      console.log("date", date);
      if (this.impType == "社保" && this.bookDate && this.belongMonth) {
        const data = {
          bookingRealMonth: this.bookDate,
          belongMonth: this.belongMonth,
          tableid: this.tabId
        }
        //判断社保是否已经导入过
        xz.isfinanceImpDataInsu(data).then(res => {
          if (res) {
            this.isimp = res.totalnum;
            console.log('ds', res.totalnum)
          }
        })
      }
    },
    //文件读取
    async importf() {
      const fileInput = this.$refs.upload;
      this.excelpath = ''
      FUN.returnExcelSrc(fileInput).then(src => {
        if (src) {
          // console.log('src0o0', src)
          this.isFileSuccess = true
          this.$set(this.ExcelSrc, "value", src.src);
          this.$set(this.ExcelSrc, "check", false);
          this.$set(this.ExcelSrc, "fileName", fileInput.files[0].name);
          // console.log('srccc', this.ExcelSrc)
          //上传excel
          const excelFile = FUN.base64ToFile(this.ExcelSrc.value, this.ExcelSrc.fileName);
          const formData = new FormData();
          formData.append("pagename", 'empexcel');
          formData.append("action", 'save');
          formData.append("userid", Cookies.get("userid-b"));
          formData.append("entid", this.entid);
          formData.append("excel", excelFile, this.ExcelSrc.fileName);
          // console.log('formData', formData)
          xz.uploadCert(formData).then(res => {
            // console.log('formData', res)
            // this.excelpath = res;
            if (this.isNull(res) || res == false) {
              this.$message('上传Excel失败!')
              this.isUploadSuccess = true
            } else {
              this.errorTxt = ''
              this.excelpath = res;
              this.isUploadSuccess = false
              this.$refs['upload'].value = null;
            }
          });
        } else {
          this.$message('上传Excel失败!')
        }
      })
    },
    //判断是否为空(包含0)
    isNull(o) {
      return o == undefined || o == "undefined" || (o + '').indexOf("undefined") > -1 || o == null || o == '' || o == 'null' || o == [] || o == 0 || o == 'NaN';
    },
    //筛选下拉
    dropDownScreen() {
      if (this.showDropScreen == -1) {
        this.showDropScreen = 1;
      } else if (this.showDropScreen == 1) {
        this.showDropScreen = -1;
      }
    },
    // 下拉选择表格
    selectTab(d) {
      this.tabId = d.value;
      this.tabName = d.label;
      if (d.value == "XZ_emp_FnncProCost") {
        this.impType = '费用';
        this.exportName = '费用'
      } else if (d.value == "XZ_emp_FnncProfit") {
        this.impType = '利润表';
        this.exportName = '利润表'
      } else if (d.value == "XZ_emp_FnncProjectInvoice") {
        this.impType = '项目开票信息表';
        this.exportName = '项目开票信息表'
      } else if (d.value == "XZ_emp_FnncSocialInsu") {
        this.impType = '社保';
        this.exportName = '项目收支表社保'
      }
      // console.log("d", d);
    },
    // 下拉选择是否覆盖
    selectReimp(d) {
      if (d == true) {
        this.reimp = 1
        this.reimpLab = 1
      } else {
        this.reimp = 0
        this.reimpLab = 0
      }
    },
    getCustomerList() {
      this.listLoading = true
      xz.getfinanceempcustlist(this.infoQuery).then((res) => {
        if (res) {
          for (var i = 0; i < res.countinf.length; i++) {
            Object.assign(res.data[i], res.countinf[i])
          }
          this.tableData = res.data;
          this.showDropScreen = -1;
          this.totalcount = parseInt(res.totalcount);
        } else {
          this.tableData = [];
          this.showDropScreen = -1;
        }
        this.listLoading = false
      })
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.page-customer .pinkButton {
  padding: 5px 10px;
  line-height: initial;
  border: solid 1px #ff6780;
  font-size: 12px;
  color: #ff6780;
  border-radius: 4px;
  background-color: #fff;
}
.page-customer .changeState {
  padding: 5px 10px;
  line-height: initial;
  border: solid 1px #f78500;
  font-size: 12px;
  color: #f78500;
  border-radius: 4px;
  background-color: #fff;
}
.page-customer .el-button.is-disabled {
  color: #c0c4cc;
  cursor: not-allowed;
  background-image: none;
  background-color: #fff;
  border-color: #ebeef5;
}
.result-box {
  padding: 15px 10px;
  border-radius: 5px;
  background-color: rgba(103, 194, 58, 0.1);
}
.top-right {
  display: flex;
  align-items: center;
}
.top-right .el-button--text {
  padding: 8px 10px;
  border: solid 1px #19bd92;
  font-size: 12px;
  color: #19bd92;
  border-radius: 4px;
  background-color: #fff;
}
.top-right .el-button--success {
  padding: 8px 20px;
  margin-right: 15px;
}
.top-right .el-button--text img {
  vertical-align: sub;
}
.form-item {
  width: 100%;
  display: flex;
  align-items: center;
  font-size: 14px;
  color: #333333;
  margin-bottom: 20px;
}
.steps-box {
  margin-top: 20px;
}
.steps-box .el-step__title {
  font-size: 14px;
  color: #999;
}
.form-item label {
  width: 56px;
  text-align: right;
}

.form-item span {
  color: #ff3228;
}

.form-item input {
  width: 400px;
  height: 40px;
  line-height: 40px;
  border: 1px solid #cccccc;
  padding-left: 14px;
  box-sizing: border-box;
  margin-top: 10px;
}

/* 这是原生的input框，给他透明隐藏，然后定位让文件上传的按钮覆盖它 */
#fileInput {
  width: 120px;
  margin-left: 8px;
  filter: Alpha(opacity=0);
  -moz-opacity: 0;
  opacity: 0;
  position: absolute;
  right: 37px;
  z-index: 2;
}
/* 这是主要的，文件上传按钮的样式 */
.file-box {
  position: relative;
}
.file-btn {
  display: inline-block;
  width: 54px;
  height: 30px;
  background: #fff;
  border: 1px solid #ccc;
  /* border-radius:2px; */
  text-align: center !important;
  line-height: 32px;
  color: #333333;
  /* position: absolute;
    top: 5px;
    right: 0; */
  margin-left: 8px;
}
/* 单行文字截断，展示文件名的input框用的 */
#applyLicense {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>

<style>
.screenInput .el-input {
  width: 100%;
  margin-left: 5px;
}
.screenInput .el-select .el-input__inner {
  height: 32px;
  line-height: 32px;
}
.screenInput .el-input__icon {
  line-height: 32px;
}
.dialog .el-dialog__header {
  padding: 0;
}
.dialog .el-dialog__body {
  padding: 20px 20px 0 20px;
}
.formScreenInput .el-input__inner {
  height: 32px;
  line-height: 32px;
  width: 180px;
  margin-top: 10px;
}
.formScreenInput .el-input__icon {
  margin-top: 10px;
  height: 32px;
  line-height: 32px;
}
.reimpArea .el-input__inner {
  height: 32px;
  line-height: 32px;
  margin-top: 10px;
}
.reimpArea .el-input__icon {
  margin-top: 10px;
  height: 32px;
  line-height: 32px;
}
.financeRosterTable .el-table th > .cell {
  padding: 0;
}
.financeRosterTable .el-table .cell {
  padding: 0;
}
.financeRosterTable .el-table td {
  padding: 6px 0;
}
.financeRosterTable .el-table th {
  padding: 12px 0;
}

.storageInput .el-input--small .el-input__inner {
  width: 368px;
  height: 32px;
}
.storageInput .el-input--small {
  width: 360px;
}
.storageArea .upload-demo {
  height: 32px;
}
.storageArea .el-button--primary {
  background-color: #fff;
  color: #000;
  border-color: #ccc;
}
.el-button--primary:focus,
.el-button--primary:hover {
  color: #409eff;
  border-color: #c6e2ff;
  background-color: #ecf5ff;
}
.storageArea .el-button {
  padding: 9px 15px;
}
.dialog .el-dialog__header {
  padding: 0;
}
.dialog .el-dialog__body {
  padding: 20px 20px 0 20px;
}
.el-popconfirm__action {
  margin-top: 15px;
}
</style>